export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, vm, info) => {
    console.error(error)
    if (!error) {
      console.error(error, { vm, info });
      return;
    }

    const err = error as Error;

    switch (err.type) {
      case 'warn':
        console.warn(err.message, { ...err, vm, info });
        warnToast(err.message);
        break;
      default:
        console.error(err.message, { ...err, vm, info });
        errorToast(err.message);
    }
  }
});